export default __webpack_public_path__ + "static/media/DNo.38-9.19a1f313.jpg";